/** @jsxImportSource @emotion/react */
import { BlueLine, HeadingH2 } from 'components/landing/ui';

const Header = () => (
  <div
    css={{
      flexDirection: 'column',
      width: '100%',
      alignItems: 'flex-start',
      marginBottom: 30,
      '@media (min-width:992px) and (max-width:1365px)': { maxWidth: 400 },
    }}
  >
    <HeadingH2 css={{ marginBottom: 20 }}>Отзывы наших пользователей:</HeadingH2>
    <BlueLine height={5} width={125} />
  </div>
);

export default Header;
